import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-advertisement',
  templateUrl: './banner-advertisement.component.html',
  styleUrls: ['./banner-advertisement.component.css']
})
export class BannerAdvertisementComponent implements OnInit {
  public closeBanner: boolean | undefined;

  constructor() { }

  ngOnInit(): void {
  }

  toggleBanner(): void {
    this.closeBanner = !this.closeBanner;
  }
}
